import React from "react";

const Dashboard = () => {
  return <h1>Dashboard is here</h1>;
};

export default Dashboard;
